<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="row d-flex justify-content-between">
            <div class="col-12 col-md-8 pl-0 pr-0">
              <filterProcessWebDraft @updateFiltros="updateFiltros"><i class="fa fa-filter"></i></filterProcessWebDraft>
            </div>

            <div class="col-12 col-md-4 text-right">
              <button
                :disabled="!!loadingRelatorio"
                type="text"
                :class="'btn btn-info w-100 btn-fill mb-4 max-180 ml-auto'"
                @click.prevent="gerarExcell"
              >Baixar Relatório <i class="fa fa-table"></i></button>
            </div>
          </div>
        </div>

        <div class="col-12 d-print-none">
          <card id="card-with-table" class="strpied-tabled-with-hover" body-classes="table-responsive">
            <loading
              color="#2185d0"
              :active.sync="isLoading"
              loader="bars"
              :is-full-page="fullPage"
            ></loading>
            <template slot="header">
              <h4
                class="card-title"
              >Lista de Processos - {{ categoria || "" }} {{ titleCard(statusModal) || titleCard(statusFixo) }}</h4>
              <p class="card-category"></p>
            </template>

            <h-table
              v-if="this.paginacao.qntRegistros > 0 && table1.data.length > 0"
              @click="createEditar"
              class="table-hover table-striped d-print-none"
              :columns="table1.columns"
              :data="table1.data"
            ></h-table>

            <h4
              v-if="this.paginacao.qntRegistros <= 0 && isLoading == false || erro != '' || table1.data.length <= 0"
            >{{ erro || "Nenhum resultado foi encontrado."}}</h4>
          </card>

          <div class="row mb-4 d-none">
            <div class="col-12">
              <table id="data-table" border="1">
                <thead>
                  <tr>
                    <th colspan="3">
                      <b>{{ loginInfo.nomeEmpresa || "Empresa"}}</b>
                    </th>
                    <th style="font-size:14px !important; font-family: Arial !important;">Tracking</th>
                  </tr>
                  <tr>
                    <td colspan="3"></td>
                    <td
                      style="font-size:14px !important; font-family: Arial !important;"
                    >Data Inicial:</td>
                    <td
                      style="font-size:14px !important; font-family: Arial !important;"
                    >{{ filtros.dataInicial }}</td>
                  </tr>
                  <tr>
                    <td colspan="3"></td>
                    <td
                      style="font-size:14px !important; font-family: Arial !important;"
                    >Data Final:</td>
                    <td
                      style="font-size:14px !important; font-family: Arial !important;"
                    >{{ filtros.dataFinal }}</td>
                  </tr>
                  <tr>
                    <td colspan="3"></td>
                    <td style="font-size:14px !important; font-family: Arial !important;">Usuario:</td>
                    <td
                      style="font-size:14px !important; font-family: Arial !important;"
                    >{{ loginInfo.username }}</td>
                  </tr>
                  <tr>
                    <td colspan="3"></td>
                    <td style="font-size:14px !important; font-family: Arial !important;">Data:</td>
                    <td
                      style="font-size:14px !important; font-family: Arial !important;"
                    >{{ new Date() | moment("DD-MM-YYYY") }}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th style="font-size:14px !important; font-family: Arial !important;">Processo</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">Reference</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">Booking</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">Tipo</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">Shipper</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">Cnee</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">Deadline_Date</th>
                    <th
                      style="font-size:14px !important; font-family: Arial !important;"
                    >Deadline_Hour</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">ETD</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">ETA</th>
                    <th style="font-size:14px !important; font-family: Arial !important;">DRAFT SEND</th>
                  </tr>
                  <tr v-for="(item,index) in relatorio" v-bind:key="index">
                    <td
                      style="font-size:14px !important; font-family: Arial !important; word-break:break-all;"
                      v-for="(value,index) in item"
                      v-bind:key="index"
                    >{{value}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
        </div>

        <modal
          name="modal"
          :adaptive="true"
          :clickToClose="false"
          :width="capa.size"
          :class="'modalInfo'"
          :scrollable="true"
          height="auto"
          @before-close="clearCapa"
          :reset="true"
        >
          <div id="print" class="container-fluid">
            <div class="row">
              <loading
                color="#2185d0"
                :active.sync="isLoading"
                loader="bars"
                :is-full-page="fullPage"
              ></loading>
              <div class="col-12">
                <div class="row">
                  <div class="col-12 col-md-6 text-center text-md-left">
                    <img :src="this.empresaInfo.logoEmpresa" alt />
                  </div>
                  <div class="info-header-capa col-md-6 col-12 text-md-right mt-auto mb-auto">
                    <h3>{{this.empresaInfo.nomeEmpresa}}</h3>
                  </div>
                </div>
                <hr />
                <!-- Conteudo -->
                <edicao :loginInfo="loginInfo" :capa="capa" @fechar="hideAndUpdate"></edicao>
                <div class="col-12 text-center">
                  <button
                    class="btn btn-info btn-fill btn-red mb-2 d-print-none"
                    @click.prevent="hide"
                  >Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </modal>

        <div class="col-12" v-if="paginacao.totalPaginas > 1">
          <card>
            <div class="col-12 text-center">
              <a class="prev-link" @click.prevent="previousPage" v-if="paginacao.page > 1"><i class="fa fa-chevron-left"></i></a>
              <span id="Page" class="pl-2 pr-2"> <input type="number" @change="changePage(paginacao.page);" style="width:50px;" v-model="paginacao.page"> de {{paginacao.totalPaginas}}</span>
              <a
                class="next-link"
                @click.prevent="nextPage"
                v-if="paginacao.page < paginacao.totalPaginas"
              ><i class="fa fa-chevron-right"></i></a>
            </div>
          </card>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import HTable from "src/components/TableEditarWebDraft.vue";
import Card from "src/components/Cards/Card.vue";
import Edicao from "src/components/Edicao.vue";
import filterProcessWebDraft from "src/components/Filters/FilterProcessWebDraft.vue";
import FilterStatus from "src/components/Filters/FilterStatus.vue";
import Capa from "src/components/Capa.vue";
import Mantra from "src/components/Mantra.vue";
import { Timeline, TimelineItem, TimelineTitle } from "vue-cute-timeline";
const tableColumns = [
  'EDITAR','PROCESSO','REFERENCE','BOOKING','TIPO','SHIPPER','CNEE','DEADLINE_DATE','DEADLINE_HOUR','ETD','ETA','DATE_SENT_EAWB'
];
const tableData = [
  {
    editar: true,
    processo: "",
    reference: "",
    booking: "",
    tipo: "",
    shipper: "",
    cnee: "",
    deadline_date: "",
    deadline_hour: "",
    etd: "",
    eta: "",
    date_sent_eawb: "",
  }
];

export default {
  props: ["categoria", "tipo", "statusFixo", "statusModal"],
  components: {
    HTable,
    Card,
    filterProcessWebDraft,
    FilterStatus,
    Timeline,
    TimelineItem,
    TimelineTitle,
    Capa,
    Mantra,
    Edicao
  },
  data() {
    return {
      erro: "",
      isLoading: true,
      fullPage: false,
      loginInfo: {
        username:"",
      },
      empresaInfo: {
        logoEmpresa: "",
        nomeEmpresa: "",
      },
      processoSelecionado: "",
      tipoPesquisa: "",
      statusCompletos: false,
      relatorio: "",
      loadingRelatorio: true,
      table1: {
        columns: [...tableColumns],
        data: [...tableData]
      },
      paginacao: {
        page: 0,
        totalPaginas: 0,
        lmtRegistros: 20,
        qntRegistros: 0
      },
      filtros: {
        referencia: "",
        porto: "",
        periodo: "",
        contato: "",
        dataInicial: "",
        dataFinal: "",
        tipoBusca: ""
      },
      mantra:{
        status: false,
      },
      capa: {
        status: false,
        size: '80%',
        leftSize: 'col-12',
        rightSize: 'col-12',
        descriptionSize: '',
        dadosGerais: {
          id:'',
          processo:'',
          reference:'',
          booking:'',
          tipo:'',
          shipper:'',
          cnee:'',
          deadline_date:'',
          deadline_hour:'',
          etd:'',
          eta:'',
          date_sent_eawb: '',
        },
        containers: {},
        tiposContainers: []        
      },
    };
  },
  methods: {
    createEditar(info) {
      (this.isLoading = true), (this.processoSelecionado = info.processo);
      var url = this.$urlApi + "/api/processowebdraft-edicao";
      let data = { processo: info.processo, statusModal: this.statusModal, tipo: this.tipo};
      this.last_status = info.last_status;
      this.axios.post(url, data).then(res => {
        if(res.data.response){
          console.log(res.data.response[0]);
          this.capa.dadosGerais = res.data.response[0];
          this.capa.containers = res.data.containers;
          this.capa.tiposContainers = res.data.tiposContainers;
          this.capa.descriptionSize = res.data.MAXLENGHTDESCRIPTION;
          this.capa.charsInRows = res.data.MAXCHARINROWS;
          console.log(this.capa);
          this.isLoading = false;
          this.show();
        }else{
          this.isLoading = false;
          this.hide();
        }
      });
    },
    getProcessos() {
      this.isLoading = true;
      let loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
      this.loginInfo = loginInfo;
      let args = {
        categoria: this.categoria,
        tipo: this.tipo,
        paginacao: this.paginacao,
        filtros: this.filtros,
        statusFixo: this.statusFixo,
        statusModal: this.statusModal
      };
      let data = { loginInfo, args };
      var url = this.$urlApi + "/api/processowebdraft";
      this.axios.post(url, data).then(res => {
        if(res.data.status){
          console.log(res.data);
          this.table1.data = res.data.response.resultado;
          this.isLoading = false;
          this.paginacao = res.data.response.paginacao;
          this.erro = "";
        }else{
          this.erro = res.data.response;
          this.isLoading = false;
        }
      });
    },
    updateFiltros(filtros) {
      this.filtros = filtros;
      this.clearPagination();
      this.getProcessos();
      this.gerarRelatorio();
      //this.clearFiltros();
    },
    nextPage() {
      this.paginacao.page++;
      this.getProcessos();
    },
    previousPage() {
      this.paginacao.page--;
      this.getProcessos();
    },
    show() {
      this.$modal.show("modal");
    },
    hide() {
      this.$modal.hide("modal");
      this.capa.status = false;
      this.capa.leftSize = "col-12";
      this.capa.rightSize = "col-12"
    },
    hideAndUpdate() {
      this.$modal.hide("modal");
      this.getProcessos();
      this.capa.status = false;
      this.capa.leftSize = "col-12";
      this.capa.rightSize = "col-12";
    },
    clearCapa() {
      this.capa.listStatus = [];
      this.capa.status = false;
    },
    clearPagination() {
      this.paginacao = {
        page: 0,
        totalPaginas: 0,
        lmtRegistros: 20,
        qntRegistros: ""
      };
    },
    clearFiltros() {
      this.filtros = {
        referencia: "",
        po: "",
        wh: "",
        porto: "",
        periodo: "",
        contato: "",
        dataInicial: "",
        dataFinal: "",
        tipoBusca: ""
      };
    },
    checkStatus(ultimo, atual, data) {
      let dataTrue;
      if(data.DATA_OK){
        dataTrue = data.DATA_OK;
      }else if(typeof data === "string" && data){
        dataTrue = data;
      }
      // console.log(data);
      if (ultimo == atual || dataTrue != null || data === true) {
        return true;
      }
      return false;
    },
    isBoolean(valor){
     
      if(typeof valor === "boolean"){
        return "";
      }else if(valor.DATA_OK){
       return " - " + valor.DATA_OK;
      }else if(typeof valor === "string"){
        return " - " + valor;
      }else{
        return "";
      }
    },
    imprimirDetalhes(){
      this.$htmlToPaper('print');
    },
    titleCard(valor){
      if(valor){
        return " - " + valor;
      }else{
        return "";
      }
    },
    gerarRelatorio() {
      this.isLoading = true;
      let loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
      let args = {
        categoria: this.categoria,
        tipo: this.tipo,
        paginacao: this.paginacao,
        filtros: this.filtros,
        statusFixo: this.statusFixo,
        statusModal: this.statusModal
      };
      let data = { loginInfo, args };
      var url = this.$urlApi + "/api/processoswebdraft-gerar-relatorios";
      this.axios.post(url, data).then(res => {
        // console.log(res.data.response);
        this.relatorio = res.data.response.resultado;
        this.loadingRelatorio = false;
      });
    },
    gerarExcell() {
      var tableToExcel = (function() {
            var uri = 'data:application/vnd.ms-excel;base64,'
                , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><meta charset="utf-8"/><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
            return function(table, name) {         
                table = document.getElementById("data-table")
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
                window.location.href = uri + base64(format(template, ctx))
            }
        })()
        tableToExcel();
    },
    checkLoadingRelatorio(){
      if(this.loadingRelatorio && this.loadingRelatorio == false){
        return "";
      }else{
        return "disabled";
      }
    },
    checkEmpresaInfo() {
      let info = JSON.parse(sessionStorage.getItem("empresaInfo"));
      //console.log(info);
      if (info) {
        if (info.hasOwnProperty("LINK")) {
          if (info.LINK != "" && info.LINK != null)
            this.empresaInfo.logoEmpresa = info.LINK;
        }
        if (info.hasOwnProperty("NOME")) {
          if (info.NOME != "" && info.NOME != null)
            this.empresaInfo.nomeEmpresa = info.NOME;
        }
      }
    },
    changePage(){
      if(this.paginacao.page < 1 || this.paginacao.page > this.paginacao.totalPaginas ){
          this.paginacao.page = 1;
      }
      this.getProcessos();
    },
    checarTipo(processo){
      let tipo = processo.substring(0,3);
      return tipo;
    }
    },
  mounted() {
    this.tipoPesquisa = this.$props.tipo;
    this.getProcessos();
    this.gerarRelatorio();
    this.checkEmpresaInfo();
    this.$emit("changeTipo", this.tipoPesquisa);
  },
  updated() {
    if (this.tipoPesquisa != this.$props.tipo) {
      this.processoSelecionado = "";
      this.tipoPesquisa = this.$props.tipo;
      this.clearPagination();
      this.getProcessos();
      this.gerarRelatorio();
      this.$emit("changeTipo", this.tipoPesquisa);
    }
  },
  watch: {
    statusFixo: function(newVal, oldVal) {
      if (typeof newVal !== "undefined") {
        // //console.log("Status Fixo");
        this.clearPagination();
        this.getProcessos();
        this.gerarRelatorio();
      }
    },
    statusModal: function(newVal, oldVal) {
      if (typeof newVal !== "undefined") {
        // //console.log("Status Dinamico");
        this.clearPagination();
        this.getProcessos();
        this.gerarRelatorio();
      }
    }
  }
};
</script>
<style>

#card-with-table .table-responsive{
  overflow: auto !important;
}
.next-link,
.prev-link,
.current-link {
  padding: 10px;
}
.prev-link,
.next-link {
  cursor: pointer;
  background: #1DC7EA;
  border-radius: 4px;
}

#Page input::-webkit-outer-spin-button,
#Page input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prev-link i,
.next-link i {
  color:white;
}

.prev-link:hover,
.next-link:hover{
  background: #18a6c3;
}

.current-link {
  padding: 10px;
}
.timeline {
  border-left: 1px solid;
}
.timeline-item {
  position: relative;
  margin: 0em 0 0 28px !important;
  padding-bottom: 0;
  border-bottom: 1px dotted var(--timelineTheme);
}
.timeline-item p {
  font-size: 12px !important;
}
.info-header-capa h3 {
  font-size: x-large;
}
.info-header-capa p {
  font-size: 12px;
  margin: 0px;
  padding: 0px;
}

.dropdown-item .router-link-exact-active,
.dropdown-item.active {
  background: #1dc7ea;
  color: white;
}

.max-180{
  max-width: 210px;
}

h3 {
  margin-top: 0px;
  padding-top: 5px;
  font-size: 20px;
}

.data{
  font-weight: bold;
}
@media print {
  #print {
    margin-left: -500px;
    z-index: 9999;
  }
}
</style>
